import {getAccountsVoucher} from "./actions";

export function setAccounts(state, data) {
    state.accounts_form = data;
}
export function setLoading(state, data) {
    state.loading.module = data;
}
export function setAccountsVoucher(state, data) {
    state.accounts_voucher = data;
}
export function setReportData(state, data) {
    state.balance_conciliation = data;
}

export function setDefaultVoucher(state,data){
    let default_v  = data.find(ele => ele.code_voucher_type === '314')
    state.payload.voucherType_id = default_v?default_v.id : null
}

export function setDefaultContact(state,contact){
    let contact_def = state.contacts.find(el => el.id === contact.id)
    if (!contact_def){
        state.contacts.push(contact)
    }
}


export function setContacts(state, contacts) {
    state.contacts = contacts;
}

export function setConsecutive(state,consecutive){
    let consecutive_number = consecutive.consecutive_number+1
    state.payload.num_doc = consecutive_number.toString()
    state.payload.prefix = consecutive.prefix
}

export function setDataVoucherTransaction(state,data){
    if (data.debit_credit === 'C'){
        state.payload.total_credit = data.value
    }else{
        state.payload.total_debit = data.value
    }
    state.payload.document_transaction = data
}

export function updateVoucherPayload(state,document_transaction){


    let transaction = document_transaction;
    transaction.id_document_transactions = document_transaction.id
    transaction.value = document_transaction.operation_value
    transaction.debit_credit = document_transaction.transactions_type
    transaction.observation = document_transaction.observations

    state.payload.document_id = document_transaction.document_id
    state.payload.document_transactions.push(transaction)
}
export function setFinalizeVoucher(state,data){
    state.file_name = data.accounting_link
    state.show_pdf  = true
}
export function clearParamsTransaction(state,data){
    state.show_pdf  = false
    state.balance_conciliation  = []
    state.params.account_id = null
    state.params.type_balance = null
    state.params.value_compare = null
    state.file_name = ''
    state.payload = {
        branchoffice_id: state.payload.branchoffice_id,
        voucherType_id:  state.payload.voucherType_id,
        num_doc: null,
        prefix: null,
        date: state.payload.date,
        id:null,
        contact_id: null,
        city_id: null,
        document_id: null,
        user_id: null,
        document_transaction: {
            id: null,
            account_id: null,
            affects_document_id: null,
            observation: "",
            contact_id: 0,
            no_doc: null,
            value: 0,
            base_value: 0,
            order: 1,
            projects_column_visible: 0,
            contact_column_visible: true,
            cost_center_column_visible: false,
            base_value_column_visible: false,
            manage_document: false,
            validation_no_doc: null,
            account_code: "",
            account_name: "",
            tax_id: null,
            payment_column_visible: false,
            manage_bank_document: false,
            commissionable_concept: false,
            debit_credit: null,
            id_document_transactions: null
        },
        document_transactions: [],
        total_debit: null,
        total_credit: null,
        ids_conciliation:[],
        update_document_payments_methods:[]
    }
}




// WEBPACK FOOTER //
// ./src/modules/balance_reconciliation/mutations.js